import React, { Component } from "react";
import Header from "./header";
import SearchQuery from "./query_search_per_transaction";
import { MdArrowUpward } from "react-icons/md";
import ListSends from "./list_sends";
import DefaultMoment from "moment";
import momentTimeZone from "moment-timezone";
import loadInstructions from "./instructions";
import fixDate from "./fixdate";
import fixTime from "./fixtime";
import io from "socket.io-client";
import jwt_decode from "jwt-decode";
const url = "https://transacoes-api.all.com.br:3080";
const statusItem = require("../status.json");

let searchValue = "";
let status = [];

class Query extends Component {
  state = {
    idEmployeeLogged: "",
    loading: true,
    movements: [],
    items: [],
    senders: [],
    filteredContent: false,
    selectedContentMovement: [],
    selectedContentItem: [],
    filter: "",
    option: "movements"
  };

  socket = io(url);

  async componentDidMount() {
    this.eventListenerSocket();
    loadInstructions("Listagem dos envios registrados por malote.");
    await this.getUserLogged();
    this.getData();
  }

  getData = () => {
    this.getMovement();
    this.getItem();
    this.getSender();
  };

  eventListenerSocket = () => {
    this.socket.on("data", () => this.getData());
  };

  getUserLogged = async () => {
    if (localStorage.getItem("token") !== null) {
      const userToken = JSON.parse(localStorage.getItem("token").toString());
      let decoded = jwt_decode(userToken.token);
      await this.setState({
        idEmployeeLogged: decoded.id.toString()
      });
    } else
      this.setState({
        idEmployeeLogged: ""
      });
  };

  getMovement = () => {
    fetch(`${url}/movimentacoes/${this.state.idEmployeeLogged}`)
      .then(response => response.json())
      .then(movement => {
        if (movement.length > 0) {
          let filteredMovement = movement.filter(
            movement => movement.result !== 0
          );
          this.setState({ movements: filteredMovement, loading: false });
        } else {
          this.setState({ movements: [], loading: false });
        }
      });
  };

  getItem = () => {
    fetch(`${url}/itens/${this.state.idEmployeeLogged}`)
      .then(response => response.json())
      .then(item => {
        if (item.length > 0) {
          let filteredItem = item.filter(item => item.result !== 0);
          this.setState({ items: filteredItem, loading: false });
        } else {
          this.setState({ items: [], loading: false });
        }
      });
  };

  getSender = () => {
    fetch(`${url}/funcionarios`)
      .then(response => response.json())
      .then(sender => {
        if (sender)
          this.setState({
            senders: sender,
            loading: false
          });
        else this.setState({ senders: [], loading: false });
      });
  };

  handleSearch = value => {
    this.setState({
      selectedContentMovement: [],
      selectedContentItem: [],
      filteredContent: false
    });
    searchValue = value;
    this.handleFilter(this.state.filter);
    this.filterContentSearch(searchValue);
  };

  handleFilter = async e => {
    await this.setState({
      filter: e,
      selectedContentMovement: [],
      selectedContentItem: [],
      filteredContent: false
    });
    this.filterContentSearch(searchValue);
  };

  handleOption = async option => {
    await this.setState({ option: option });
    this.filterContentSearch(searchValue);
  };

  filterContentSearch = value => {
    if (this.state.filter !== "") {
      let selectContent,
        selectContentItem = [];
      if (
        this.state.movements.length > 0 &&
        this.state.option === "movements"
      ) {
        selectContent = this.state.movements.filter(movement => {
          let sender = [],
            count = 0;
          if (movement.id_transacao === parseInt(this.state.filter, 10)) {
            sender = this.state.senders.filter(sender =>
              sender.usuario
                .toLowerCase()
                .replace(".", " ")
                .includes(value.toLowerCase())
            );
            if (sender.length > 1) {
              count = sender.length;
            } else count = 0;
            return (
              movement.id_transacao.toString().includes(value.toLowerCase()) ||
              movement.id_movimentacao
                .toString()
                .includes(value.toLowerCase()) ||
              (
                value.length === 2 &&
                DefaultMoment(movement.created_at).format("DD")
              )
                .toString()
                .includes(fixDate(value)) ||
              (
                value.length === 2 &&
                DefaultMoment(movement.updated_at).format("DD")
              )
                .toString()
                .includes(fixDate(value)) ||
              (
                value.length === 5 &&
                DefaultMoment(movement.created_at).format("MM/DD")
              )
                .toString()
                .includes(fixDate(value)) ||
              (
                value.length === 5 &&
                DefaultMoment(movement.updated_at).format("MM/DD")
              )
                .toString()
                .includes(fixDate(value)) ||
              (
                value.length === 10 &&
                DefaultMoment(movement.created_at).format("YYYY/MM/DD")
              )
                .toString()
                .includes(fixDate(value)) ||
              (
                value.length === 10 &&
                DefaultMoment(movement.updated_at).format("YYYY/MM/DD")
              )
                .toString()
                .includes(fixDate(value)) ||
              (
                value.length === 2 &&
                momentTimeZone(movement.created_at)
                  .tz("UTC")
                  .format("HH")
              )
                .toString()
                .includes(fixTime(value)) ||
              (
                value.length === 2 &&
                momentTimeZone(movement.updated_at)
                  .tz("UTC")
                  .format("HH")
              )
                .toString()
                .includes(fixTime(value)) ||
              (
                value.length === 5 &&
                momentTimeZone(movement.created_at)
                  .tz("UTC")
                  .format("HH:mm")
              )
                .toString()
                .includes(fixTime(value)) ||
              (
                value.length === 5 &&
                momentTimeZone(movement.updated_at)
                  .tz("UTC")
                  .format("HH:mm")
              )
                .toString()
                .includes(fixTime(value)) ||
              (
                value.length === 8 &&
                momentTimeZone(movement.created_at)
                  .tz("UTC")
                  .format("HH:mm:ss")
              )
                .toString()
                .includes(fixTime(value)) ||
              (
                value.length === 8 &&
                momentTimeZone(movement.updated_at)
                  .tz("UTC")
                  .format("HH:mm:ss")
              )
                .toString()
                .includes(fixTime(value)) ||
              movement.status.toLowerCase().includes(value.toLowerCase()) ||
              (sender.length > 0
                ? value.length === count
                  ? movement.id_remetente === sender[0].id
                  : movement.id_remetente === sender[0].id
                : false) ||
              (sender.length > 0
                ? value.length === count
                  ? movement.id_destinatario === sender[0].id
                  : movement.id_destinatario === sender[0].id
                : false)
            );
          } else {
            return false;
          }
        });
        this.setState({
          selectedContentMovement:
            selectContent.length > 0 ? selectContent : false,
          filteredContent: true
        });
      } else {
        this.setState({
          filteredContent: false
        });
      }
      if (!selectContent && this.state.option === "items") {
        if (this.state.items.length > 0) {
          status = statusItem.filter(status =>
            status.status.toLowerCase().includes(value.toLowerCase())
          );
          selectContentItem = this.state.items.filter(item => {
            return (
              item.id_item.toString().includes(value.toLowerCase()) ||
              item.tipo.toLowerCase().includes(value.toLowerCase()) ||
              item.descricao.toLowerCase().includes(value.toLowerCase()) ||
              item.patrimonio.toString().includes(value) ||
              item.observacao.toLowerCase().includes(value.toLowerCase()) ||
              (status.length > 0 && item.status === status[0].id_status)
            );
          });
          let i = 0,
            j = 0,
            selectContentItemLength = selectContentItem.length;
          let findMovement = [];
          for (i = 0; i < this.state.movements.length; ++i) {
            for (j = 0; j < selectContentItemLength; ++j) {
              if (
                this.state.movements[i].id_item ===
                  selectContentItem[j].id_item &&
                this.state.movements[i].id_transacao ===
                  parseInt(this.state.filter, 10)
              ) {
                findMovement[i] = this.state.movements[i];
              }
            }
          }
          this.setState({
            selectedContentMovement:
              findMovement.length > 0 ? findMovement : false,
            filteredContent: true
          });
        } else {
          this.setState({
            filteredContent: false
          });
        }
      }
    }
  };

  scrollTop = () => {
    window.scrollTo(0, 0);
  };

  render() {
    const {
      movements,
      items,
      senders,
      selectedContentMovement,
      selectedContentItem,
      filter,
      loading
    } = this.state;
    return (
      <React.Fragment>
        <Header title={"Consulta"} activeNavContent={true} />
        <div
          className="search"
          style={{
            float: "center",
            margin: "auto",
            width: "100%",
            display: "block",
            position: "fixed",
            zIndex: "10"
          }}
        >
          <SearchQuery
            handleFilter={e => this.handleFilter(e)}
            handleSearch={e => this.handleSearch(e)}
            handleOption={e => this.handleOption(e)}
          />
        </div>
        {loading && (
          <div
            className="preloader-wrapper big active"
            style={{
              display: "block",
              margin: "auto",
              float: "center",
              marginTop: "130px"
            }}
          >
            <div className="spinner-layer spinner-red-only">
              <div className="circle-clipper left">
                <div className="circle" />
              </div>
              <div className="gap-patch">
                <div className="circle" />
              </div>
              <div className="circle-clipper right">
                <div className="circle" />
              </div>
            </div>
          </div>
        )}
        {!loading && (
          <center>
            <ListSends
              selectedContent={
                selectedContentMovement.length === 0
                  ? true
                  : selectedContentMovement
              }
              filter={filter && filter}
              movements={movements.length > 0 && movements}
              items={items.length > 0 && items}
              senders={senders.length > 0 && senders}
              selectedContentItem={
                selectedContentItem.length > 0 && selectedContentItem
              }
            />
            <a
              disabled={
                selectedContentMovement.length > 0 || movements.length > 0
                  ? false
                  : true
              }
              href="#up"
              className="btn-floating btn-large halfway-fab waves-effect waves-light"
              style={{
                position: "fixed",
                bottom: "20px",
                right: "7px",
                backgroundColor: "#357ae8"
              }}
              onClick={() => this.scrollTop()}
            >
              <i className="material-icons">
                <MdArrowUpward />
              </i>
            </a>
          </center>
        )}
      </React.Fragment>
    );
  }
}

export default Query;
